/* 所有的CGI都配置在这 */
export const API_REQUEST = 'API_REQUEST';

// 用户资料页、用户相册相关
export const GET_USER_ALBUM = 'GET_USER_ALBUM';
export const GET_USER_INFO = 'GET_USER_INFO';
export const GET_QQHY_USER_INFO = 'GET_QQHY_USER_INFO';
export const SET_USER_ALBUM = 'SET_USER_ALBUM';
export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_USER_INFO_TYPE = 'SET_USER_INFO_TYPE';
export const FOLLOW = 'FOLLOW';
export const GET_FOLLOW = 'GET_FOLLOW';
export const GET_FANS = 'GET_FANS';
export const SET_USER_VOICE_COVER = 'SET_USER_VOICE_COVER';
export const GET_USER_VOICE_COVER = 'GET_USER_VOICE_COVER';
export const GET_USER_BADGES = 'GET_USER_BADGES';

// 【房间管理】 拉取房间信息、管理员、封禁、禁言列表 （charley负责）
export const GET_MANAGER_LIST = 'GET_MANAGER_LIST';
export const GET_MUTE_LIST = 'GET_MUTE_LIST';
export const GET_FORBID_LIST = 'GET_FORBID_LIST';
export const GET_ROOM_CONFIG = 'GET_ROOM_CONFIG';

export const EDIT_ROOM_NAME = 'EDIT_ROOM_NAME';
export const EDIT_ROOM_STAGE_MODE = 'EDIT_ROOM_STAGE_MODE';
export const SET_ROOM_PLAY_TYPE = 'SET_ROOM_PLAY_TYPE';
export const SET_ROOM_CONFIG = 'SET_ROOM_CONFIG'; // 访客限制设置
export const SET_ROOM_MANAGER = 'SET_ROOM_MANAGER';
export const SET_FORBID_STATUS = 'SET_FORBID_STATUS'; // 解除封禁、禁言

// 【房间管理】 主播设置 主播限时 （由金隆负责）发言方式 （charley负责）
export const EDIT_ANCHOR_CONFIG = 'EDIT_ANCHOR_CONFIG';

// 【房间管理】 麦序记录 （由cody负责）
export const GET_SEQUENCE_RECORD = 'GET_SEQUENCE_RECORD';

// 【房间榜单】 获取榜单数据
export const GET_CHARM_DAY = 'GET_CHARM_DAY';
export const GET_CHARM_WEEK = 'GET_CHARM_WEEK';
export const GET_RICH_DAY = 'GET_RICH_DAY';
export const GET_RICH_WEEK = 'GET_RICH_WEEK';

export const GET_ANCHOR = 'GET_ANCHOR';

export const GET_CONTRIBUTION = 'GET_CONTRIBUTION';

// 连麦
export const GET_LINE_DETAIL = 'GET_LINE_DETAIL';
export const EDIT_LINE_USER = 'EDIT_LINE_USER';

// 充值页
export const GET_BALANCE = 'GET_BALANCE';
export const GIFT_PAY_SWITCH = 'GIFT_PAY_SWITCH';

// 每日任务
export const GET_TASK_INFO = 'GET_TASK_INFO';
export const GET_TASK_AWARD = 'GET_TASK_AWARD';
export const GET_ACTIVE_INFO = 'GET_ACTIVE_INFO';
export const GET_ACTIVE_AWARD = 'GET_ACTIVE_AWARD';

// 我的等级
export const GET_USER_EXP_LEV = 'GET_USER_EXP_LEV';

// 个人中心页
export const GET_PERSONAL_CENTER = 'GET_PERSONAL_CENTER';
export const GET_ROOM_TRACE = 'GET_ROOM_TRACE';
export const CLEAN_ROOM_TRACE = 'CLEAN_ROOM_TRACE';

// 提现相关
export const WITHDRAW = 'WITHDRAW';
export const GET_CASH_RECORD_LIST = 'GET_CASH_RECORD_LIST';
export const GET_SHOW_EARNINGS_LIST = 'GET_SHOW_EARNINGS_LIST';
export const GET_MANAGE_EARNINGS_LIST = 'GET_MANAGE_EARNINGS_LIST';
export const GET_HOST_EARNINGS_DETAIL = 'GET_HOST_EARNINGS_DETAIL';

//承接页
export const GET_TRANSIT_PAGE_INFO = 'GET_TRANSIT_PAGE_INFO';

// 获取爵位信息
export const GET_NOBILITY_INFO = 'GET_NOBILITY_INFO';

// 获取爵位保级卡(黄马褂)信息
export const GET_RELEGATION_INFO = 'GET_RELEGATION_INFO';

// 承接页v2
export const GET_ENTRY_INFO_V2 = 'GET_ENTRY_INFO_V2';

// 承接页v2打开状态
export const SET_HALL_OPTION = 'SET_HALL_OPTION';

// 大厅
export const GET_QUN_ROOM = 'GET_QUN_ROOM';
export const GET_QUN_SAME_CITY_ROOM = 'GET_QUN_SAME_CITY_ROOM';
export const GET_QUN_KSONG_JIAOYOU_ROOM = 'GET_QUN_KSONG_JIAOYOU_ROOM';

// 编辑舞台
export const EDIT_STAGE = 'EDIT_STAGE';

// 主播推荐图设置
export const GET_HOST_INFO = 'GET_HOST_INFO';
export const SET_HOST_INFO = 'SET_HOST_INFO';

// 上传图片通用接口
export const UPLOAD_IMAGE = 'UPLOAD_IMAGE';

export const GET_DAY_RANK_LIST = 'GET_DAY_RANK_LIST';
export const GET_WEEK_RANK_LIST = 'GET_WEEK_RANK_LIST';
export const GET_RECORD_LIST = 'GET_RECORD_LIST';
export const GET_MYRECORD_LIST = 'GET_MYRECORD_LIST';
export const GET_DRAW_RESULT = 'GET_DRAW_RESULT';
export const GET_GIFT_CONFIG = 'GET_GIFT_CONFIG';
export const GET_DRAW_EXCHANGE = 'GET_DRAW_EXCHANGE';

// 获取我加入的群
export const GET_MY_GROUP = 'GET_MY_GROUP';

/**
 * 是否使用Mock的路径
 */
export const IS_MOCK = false;
